/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */

import { Modal, Skeleton } from 'antd'
import BaseEmptyBlock from 'components/elements/BaseEmpty/BaseEmptyBlock'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { FC, useState } from 'react'
import PurchaseCreditPlanItem from './PurchaseCreditPlanItem'
import { useGetCreditPlanQuery } from '../api'
import PurchasePaymentBlock from './PurchasePaymentBlock'
import { TCreditPaymentDetails } from '../types'
import { useCreditContext } from '../providers/CreditsContext'

const stripePromise = loadStripe(
 process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? '',
)

const PurchaseCreditPlan: FC<{
 visible?: boolean
 onCancel?: () => void
 onSuccuss?: () => void
}> = ({ onSuccuss, onCancel, visible }) => {
 const { type } = useCreditContext()
 const { data, isLoading } = useGetCreditPlanQuery({
  credit_type: type ?? 'sms',
 })

 const [paymentData, setPaymentData] = useState<TCreditPaymentDetails>()

 return (
  <Modal
   forceRender
   footer={null}
   title={paymentData ? 'Checkout' : 'Choose Plan'}
   visible={visible}
   onCancel={onCancel}
  >
   {paymentData ? (
    <Elements
     options={{
      clientSecret: paymentData?.clientSecret,
      appearance: {
       theme: 'stripe',
      },
     }}
     stripe={stripePromise}
    >
     <PurchasePaymentBlock purchaseData={paymentData} onSuccuss={onSuccuss} />
    </Elements>
   ) : (
    <>
     {isLoading ? (
      <div>
       <Skeleton />
      </div>
     ) : data?.length === 0 ? (
      <BaseEmptyBlock />
     ) : (
      <div className="purchase-credit-plan">
       <ul>
        {data?.map((item, index) => (
         <PurchaseCreditPlanItem
          item={item}
          key={index}
          onBeforePayment={(v) => setPaymentData(v)}
         />
        ))}
       </ul>{' '}
      </div>
     )}
    </>
   )}
  </Modal>
 )
}

export default PurchaseCreditPlan
